import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { SupportTicketService } from '../../Model/Support/support-ticket.service';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../Util/Session/session.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { Router, RouterModule } from '@angular/router';
import { ViewSupportProfileComponent } from '../view-support-profile/view-support-profile.component';
import { ViewSalarySlipComponent } from '../view-salary-slip/view-salary-slip.component';
import { SalarySummaryDetailsComponent } from '../salary-summary-details/salary-summary-details.component';
import { ViewUniformDetailComponent } from '../view-uniform-detail/view-uniform-detail.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../Model/Combo/combo.service';
import { AttendanceSummaryComponent } from '../attendance-summary/attendance-summary.component';

@Component({
  selector: 'app-support-ticket-form',
  standalone: true,
  imports: [FormsModule, CommonModule, LoaderComponent, RouterModule,NgSelectModule],
  templateUrl: './support-ticket-form.component.html',
  styleUrl: './support-ticket-form.component.scss'
})
export class SupportTicketFormComponent {
  isDisabled: boolean = false;
  @Input() InputData: any;
  Remarks: string = '';

  Attachment: string = '';
  selectedFile: File | null = null;
  ImageUrl: any;
  public User: any = null;
  // Name : string = '';
  Closedate : any = null;
  ESS_ComplaintTypeId :any = null
  ComplaintTypeData : any[] = []
  constructor(public activeModal: NgbActiveModal,
    private toast: ToastService,
    private support: SupportTicketService,
    private modalService: NgbModal,
    protected common: CommonService,
    private tooltip: TooltipService,
    private sessionService: SessionService,
    private utility: UtilityService,
    private router: Router,
    private combo: ComboService,
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.SelectDate('RegistrationDate', null, null);
  }

  ngOnInit() {
    this.ComboLoad('ComplaintType');
    this.Attachment = this.InputData.Attachment
    this.ImageUrl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'HelpDeskSupport' + '/' + this.Attachment
    this.ESS_ComplaintTypeId = this.InputData.ESS_ComplaintTypeId
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Closedate = response.Table[0].RegistrationDate
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  Close(type: boolean) {
    this.activeModal.close(type);
  }

  async save() {
    await this.common.getPageRights();
    // if (this.Name.trim() === '') {
    //   this.toast.show({ message: 'Please Enter Name.', type: toastTypeEnum.warning });
    //   return
    // }
    if (this.ESS_ComplaintTypeId === '' || this.ESS_ComplaintTypeId === null) {
      this.toast.show({ message: 'Please select Complaint Type.', type: toastTypeEnum.warning });
      return
    }
    if (this.Remarks.trim() === '') {
      this.toast.show({ message: 'Please Enter Remarks.', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save and close the Ticket ?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          this.SaveUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }
  SaveUpdate() {
    const Detail = {
      SelectType: 'U',
      ESS_HelpDeskRequestId: this.InputData.ESS_HelpDeskRequestId,
      ESS_ComplaintTypeId: this.ESS_ComplaintTypeId ,//this.InputData.ESS_ComplaintTypeId,
      AdditionalDetails: this.InputData.AdditionalDetails,
      EmpMasterId: this.InputData.EmpMasterId,
      ContactNo: this.InputData.ContactNo,
      Description: this.InputData.Description,
      Status: this.InputData.type,
      Remarks: this.Remarks,
      UserId: this.InputData.UserId,
      Attachment: this.InputData.Attachment,
      AssignedTo: '',
      
      closedtoMailId : this.InputData.closedtoMailId,
      ticketID : this.InputData.ESS_HelpDeskRequestId,
      assignedbyName : this.InputData.assignedbyName,
      ticketDescription : this.InputData.Description,
      ticketRaisedDate : this.InputData.ticketRaisedDate,
      //Status : ''
      companyName : this.InputData.companyName,
      dateClosed : this.Closedate
    }
    this.isDisabled = true;
    this.support.ESS_HelpDeskRequest_Insert(Detail).subscribe({
      next: (data) => {
        if (data.Error_Code == '453') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message =  data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Close(true)
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
    });
  }

  onFileSelected(event: any) {
    this.isDisabled = true;
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    if (this.selectedFile) {
      this.uploadToFTP(this.selectedFile);
      this.isDisabled = false;
    } else {
      this.isDisabled = false;
    }
  }
  removeFile() {
    this.selectedFile = null;
    this.Attachment = '';
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    window.open(this.ImageUrl, '_blank');
  }
  uploadToFTP(file: File) {
    if (!file) {
      return;
    }
    this.isDisabled = true;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'HelpDeskSupport', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          this.Attachment = response.FileName;
          this.ImageUrl = response.Url;
          this.isDisabled = false;
        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }

  ViewProfile() {
    const modalRef = this.modalService.open(ViewSupportProfileComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      EmpMasterId: this.InputData.EmpMasterId,
    };
    modalRef.result.then((result) => {
      if (result) {
        window.location.reload();
      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }
  // ViewSalarySlip() {
  //   const modalRef = this.modalService.open(ViewSalarySlipComponent, { centered: true, backdrop: 'static', size: 'xl' });
  //   modalRef.componentInstance.InputData = {
  //     EmpMasterId: this.InputData.EmpMasterId,
  //     EmpName: this.InputData.EmpName,
  //     EmpCode: this.InputData.EmpCode,
  //     SiteName: this.InputData.SiteName,
  //     DesignationName: this.InputData.DesignationName,
  //     Photo: this.InputData.Photo
  //   };
  //   modalRef.result.then((result) => {
  //     if (result) {
  //       //window.location.reload();
  //     }
  //   }).catch((reason) => {
  //     console.log('Modal dismissed:', reason);
  //   });
  // }
  ViewSalaryDetails() {
    const modalRef = this.modalService.open(SalarySummaryDetailsComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      EmpMasterId: this.InputData.EmpMasterId,
      // EmpName: this.InputData.EmpName,
      // EmpCode: this.InputData.EmpCode,
      // SiteName: this.InputData.SiteName,
      // DesignationName: this.InputData.DesignationName,
      // Photo: this.InputData.Photo
    };
    modalRef.result.then((result) => {
      if (result) {

      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  ViewUniform(){
    const modalRef = this.modalService.open(ViewUniformDetailComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      EmpMasterId: this.InputData.EmpMasterId,
      EmpName: this.InputData.EmpName,
      EmpCode: this.InputData.EmpCode,
      // SiteName: this.InputData.SiteName,
      DesignationName: this.InputData.DesignationName,
      Photo: this.InputData.Photo
    };
    modalRef.result.then((result) => {
      if (result) {

      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'ComplaintType') {
          this.ComplaintTypeData = response.ComboLoad;
        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ViewAttandance() {
    const modalRef = this.modalService.open(AttendanceSummaryComponent, { centered: true, backdrop: 'static', size: 'xl' });
    modalRef.componentInstance.InputData = {
      EmpMasterId: this.InputData.EmpMasterId,
      EmpName: this.InputData.EmpName,
      EmpCode: this.InputData.EmpCode,
      DesignationName: this.InputData.DesignationName,
      Photo: this.InputData.Photo,
      IsDate : true
    };
    modalRef.result.then((result) => {
      if (result) {

      }
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

}
